import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_with-appbar/error/')({
  component: RouteComponent,
})

function RouteComponent() {
  return <div>Hello "/_with-appbar/error/"!</div>
}
